import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import TvFeed from '../tvFeed';

class TvTheater extends React.PureComponent {
    static propTypes = {
        hitTv1: PropTypes.array,
        isVideoShare: PropTypes.bool,
    };

    callAppHandle = (isSendCount = true, isJumpQQlink = false, isCallAppWx = true) => {
        if (isSendCount) {
            h5PageCount([
                {
                    behavior: 'action',
                    type: 'phmoviehot',
                    other: {
                        url: encodeURIComponent(location.href),
                    },
                },
            ]);
        }

        if (isCallAppWx) {
            callApp({
                docType: 'web',
                pid: 'https://phtv.ifeng.com/loc/tvTheater?immersion=true',
                kind: 'share52208',
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1526325085897',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8981',
                isJumpQQlink,
            });
        }
    };

    render() {
        const { hitTv1, isVideoShare } = this.props;
        const schemeLink = getSchemeLink({
            docType: 'web',
            pid: 'https://phtv.ifeng.com/loc/tvTheater?immersion=true',
            kind: 'share52208',
        });

        return (
            <section className={styles.hot}>
                <div className={styles.toolbar} onClick={this.callAppHandle}>
                    <div className={styles.partTitle}>正在热播</div>
                    <div className={styles.partMore}>打开app阅读</div>
                    {!isVideoShare && (
                        <WxLaunchApp
                            launchType="app"
                            launchAppClick={this.callAppHandle.bind(this, true, false, false)}
                            schemeLink={schemeLink}
                            launchAppFail={this.callAppHandle.bind(this, false, true, true)}
                        />
                    )}
                </div>
                <div className={styles.videoList}>
                    <TvFeed content={hitTv1} moduleName="tvTheater" direction="column" isVideoShare={isVideoShare} />
                </div>
            </section>
        );
    }
}

export default errorBoundary(TvTheater);
